module.exports = __webpack_public_path__ + "img/slide-2-xl.40ecf24.webp";